import { fg } from '@atlassian/jira-feature-gating';
import { useAskRovoCommand } from '@atlassian/jira-command-palette-ask-rovo/src/ui/use-ask-rovo-command/index.tsx';
import { COMMAND_PALETTE_REGISTRY_IDS } from '@atlassian/jira-command-palette-registry/src/common/constants/registry/index.tsx';
import { useRegisterCommands } from '@atlassian/jira-command-palette-registry/src/controllers/use-register-commands/index.tsx';
import { useIssueNavigatorLink } from '../../controllers/use-issue-navigator-link/index.tsx';
import { useCopyPageUrlCommand } from './use-copy-page-url/index.tsx';
import { useNavigationCommands } from './use-navigation-commands/index.tsx';

export const useRegisterInitialCommands = (): void => {
	const copyCommand = useCopyPageUrlCommand();
	const navigationCommands = useNavigationCommands();
	const { issueNavigatorLink } = useIssueNavigatorLink();

	// eslint-disable-next-line  react-hooks/rules-of-hooks
	const askRovoCommand = fg('jjj_ask_rovo_compal_v1') ? useAskRovoCommand() : null;

	useRegisterCommands(COMMAND_PALETTE_REGISTRY_IDS.COPY_URL, [copyCommand]);
	useRegisterCommands(COMMAND_PALETTE_REGISTRY_IDS.NAVIGATION_COMMANDS, navigationCommands, [
		issueNavigatorLink,
	]);

	const askRovoCommands = askRovoCommand ? [askRovoCommand] : [];
	useRegisterCommands(COMMAND_PALETTE_REGISTRY_IDS.ASK_ROVO, askRovoCommands);
};
